import postRequest from '../../postRequest';

/**
 * Index products.
 *
 * @param {number[]} productIds
 */
  function postProducts(productIds) {
  const endpoint = '/oc-product/v1/product/metaPackProducts';
  const body = productIds.map(Number);
  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'MetaPackProducts')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default postProducts;
